import SearchIcon from "@mui/icons-material/Search";
import { InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#18333A",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#9CBF2E",
    color: "#FFF",
  },
  marginRight: theme.spacing(0.3),
  marginLeft: "0 !important",
  width: "100%",
  height: "35px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 90,
    },
  },
}));
export const SearchBar = ({ onSearch }) => {
  return (
    <>
      <Search sx={{ background: "#18333A" }}>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          sx={{ color: "white" }}
          placeholder="Search…"
          inputProps={{ "aria-label": "search" }}
          onChange={onSearch}
        />
      </Search>
    </>
  );
};
